// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2taN3","calendarButtons":"ClockData_calendarButtons__CA3ZZ"};